export interface IReason {
  reasonId: string;
  code: string;
  nameEnglish: string;
  nameArabic: string;
  descriptionEnglish: string;
  descriptionArabic: string;
  claimStatus: claimStatus[],
  claimModule: claimModule[],
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string;
  deletedDate: string;
}

interface claimStatus {
  claimStatusId: string;
  claimStatusNameEnglish: string;
  claimStatusNameArabic: string;
}

interface claimModule {
  claimModuleId: number;
  claimModuleName: string;
}

export const reasonsConfig = {
  entityName: 'CONFIGURATION.REASON.TITLE',
  code: 'FORM_FIELD.CODE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
  descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
  claimStatusId: 'CONFIGURATION.REASON.CLAIM_STATUS',
  claimModuleId: 'CLAIM_MODULE.TITLE'
};